<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">{{headerTitle}}</span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span>
</div>

<div *ngIf="!loadingView" class="dialog-container">
    <form [formGroup]="solicitudForm">
       <div class="col-12 row">
        <fieldset class="mb-4 fieldset-container">
            <div class="row">

                <div class="col-6">
                    <span class="fs-14px font-weight-bold">Solicitante</span>
                    <input class="form-control" formControlName="solicitante" type="text" maxlength="13" placeholder="Ingresa el Solicitante" />
                    <!-- <p *ngIf="mostrarError.rfc || errorValidarRfc" class="invalid-form-p">{{errorRFCMessage}}</p> -->
                </div>

                <div class="col-6">
                    <span class="fs-14px font-weight-bold">Departamento Solicitante</span>
                    <input class="form-control" formControlName="solicitante" type="text" maxlength="13" placeholder="Ingresa el Departamento" />
                    <!-- <p *ngIf="mostrarError.rfc || errorValidarRfc" class="invalid-form-p">{{errorRFCMessage}}</p> -->
                </div>

                <div class="col-6">
                    <span class="fs-14px font-weight-bold">Fecha de Solicitud</span>
                    <input class="form-control" formControlName="solicitante" type="text" maxlength="13" placeholder="fecha solicitud" />
                    <!-- <p *ngIf="mostrarError.rfc || errorValidarRfc" class="invalid-form-p">{{errorRFCMessage}}</p> -->
                </div>

                <div class="col-6">
                    <span class="fs-14px font-weight-bold">Fecha Requerida</span>
                    <input class="form-control" formControlName="solicitante" type="text" maxlength="13" placeholder="fecha requerida" />
                    <!-- <p *ngIf="mostrarError.rfc || errorValidarRfc" class="invalid-form-p">{{errorRFCMessage}}</p> -->
                </div>

                <div class="col-12">
                    <span class="fs-14px font-weight-bold">Justificante</span>
                    <input class="form-control" formControlName="justificante" type="text" maxlength="13" placeholder="Ingresa un texto" />
                    <!-- <p *ngIf="mostrarError.rfc || errorValidarRfc" class="invalid-form-p">{{errorRFCMessage}}</p> -->
                </div>
            </div>

            <span class="d-flex flex-row mt-4 align-items-center justify-content-start">
                <h4>CONCEPTOS</h4>
                <button class="btn btn-success ms-2"  (click)="addForm()">Agregar <i class="fa-solid fa-circle-plus"></i></button>
            </span>
            <form [formGroup]="conceptosForms" (ngSubmit)="onSubmit()">
                <div formArrayName="forms">
                    <div class="col-12 row" *ngFor="let group of forms.controls; let i = index" [formGroupName]="i">
                        <div class="col-12 d-flex flex-row justify-content-between align-items-center mt-3">
                            <p class="titulo-concepto">Concepto {{i + 1}}</p>
                            <button class="btn btn-danger" type="button" (click)="removeForm(i)"><i class="fa-solid fa-trash-can"></i></button>
                        </div>
                        <div class="col-4">
                            <input class="form-control" formControlName="concepto" placeholder="Campo 1">
                        </div>
                        <div class="col-4">
                            <input class="form-control" formControlName="cantidad" placeholder="Campo 2">
                        </div>
                        <div class="col-4">
                            <input class="form-control" formControlName="especificaciones" placeholder="Campo 3">
                        </div>
                        <div class="col-4">
                            <input class="form-control" formControlName="pu" placeholder="Campo 1">
                        </div>
                        <div class="col-4">
                            <input class="form-control" formControlName="total" placeholder="Campo 2">
                        </div>
                        <div class="col-4">
                            <input class="form-control" formControlName="observacione" placeholder="Campo 3">
                        </div>
                    </div>
                </div>
            </form>



            <div class="d-flex flex-row justify-content-end align-items-end w-100">
                <button class="btn btn-primary" type="submit">Guardar</button>
            </div>
        </fieldset>
       </div>
    </form>
</div>